import { RegistrationRegister, RegisterUnofficial } from '../../../helper/constants';
export const updateAccessSelector = ({ access }) => access;

export const registrationRegisterSelector = ({ access }) => {
  
    let RegistrationRegisterAccess = access.access.subNestedParentLevel.filter((v, i) =>
             v.menuItemName.trim() === RegistrationRegister && v.moduleorder === 2
           )
          
           return (RegistrationRegisterAccess.length > 0) ? RegistrationRegisterAccess[0].menuAccess : 2;
     
}

export const unofficialRegisterSelector = ({ access }) => {
  
    let RegistrationRegisterAccess = access.access.subNestedParentLevel.filter((v, i) =>
             v.menuItemName.trim() === RegisterUnofficial && v.moduleorder === 2
           )

          
           return (RegistrationRegisterAccess.length > 0) ? RegistrationRegisterAccess[0].menuAccess : 2;
     
}
